import React from 'react'
import "./Footer.css"

const FooterComponent = () => {
  return (
    <footer className="footer">
      Crypto Trading App.
      <span className="d-none d-md-inline ms-2">All Right Reserved.</span>
    </footer>
  )
}

export default FooterComponent